(function() {
  'use strict';

  /**
   * Product Information Tabs
   * Handles tab switching for product page information tabs.
   * Each tab click should hide all other tabs and show only the clicked one.
   *
   * NOTE: Tab panels can be in two locations:
   * 1. Inside .tab-content (regular tabs)
   * 2. Direct children of .product.info.detailed (widget tabs)
   */

  function initProductTabs() {
    // Select all tab navigation links
    var tabLinks = document.querySelectorAll('.bls__product-tabs .nav-tabs a.is-nav-tabs');

    tabLinks.forEach(function(link) {
      // Skip if already initialized
      if (link.hasAttribute('data-tab-initialized')) return;
      link.setAttribute('data-tab-initialized', 'true');

      link.addEventListener('click', handleTabClick);
    });
  }

  function handleTabClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var clickedLink = e.currentTarget;
    var tabId = clickedLink.getAttribute('data-block-id');

    // Find the section container
    var section = clickedLink.closest('.bls__product-tabs');
    if (!section) return;

    // Get the clicked nav item (li element)
    var clickedNavItem = clickedLink.closest('.data.item');
    if (!clickedNavItem) return;

    // Don't do anything if already active
    if (clickedNavItem.classList.contains('active')) return;

    // Get all nav items within THIS section only
    var navItems = section.querySelectorAll('.nav-tabs .data.item');

    // Get ALL tab panels - both inside .tab-content AND direct children of .product.info.detailed
    // This handles the case where widget tabs render outside .tab-content
    var tabPanels = section.querySelectorAll('.tab-item');

    // 1. Deactivate ALL nav items
    navItems.forEach(function(item) {
      item.classList.remove('active');
    });

    // 2. Hide ALL tab panels (regardless of location)
    tabPanels.forEach(function(panel) {
      panel.classList.remove('active');
      panel.style.display = 'none';
      var panelContent = panel.querySelector('.tab-panel');
      if (panelContent) {
        panelContent.style.display = 'none';
      }
    });

    // 3. Activate the clicked nav item
    clickedNavItem.classList.add('active');

    // 4. Find and show ONLY the target panel
    var targetPanel = null;

    // First try getElementById (fastest)
    if (tabId) {
      targetPanel = document.getElementById(tabId);
    }

    // Fallback: search within section
    if (!targetPanel && tabId) {
      targetPanel = section.querySelector('.tab-item[id="' + tabId + '"]');
    }

    if (targetPanel) {
      targetPanel.classList.add('active');
      targetPanel.style.display = 'block';
      var panelContent = targetPanel.querySelector('.tab-panel');
      if (panelContent) {
        panelContent.style.display = 'block';
      }

      // Re-initialize any carousels/swipers in the now-visible tab
      reinitComponents(targetPanel);
    }
  }

  function reinitComponents(container) {
    if (!container) return;

    // Give a small delay for CSS transitions to complete
    setTimeout(function() {
      // Technology swiper initialization
      var techSwiper = container.querySelector('[data-chbe-technology-swiper]');
      if (techSwiper && !techSwiper.swiper && typeof Swiper !== 'undefined') {
        new Swiper(techSwiper, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          centeredSlides: false,
          pagination: {
            el: techSwiper.querySelector('.chbe-technology__pagination'),
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            }
          }
        });
      }

      // Update existing Swipers
      var swipers = container.querySelectorAll('.swiper');
      swipers.forEach(function(el) {
        if (el.swiper) {
          el.swiper.update();
        }
      });
    }, 150);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  // Re-initialize when Shopify section is reloaded (theme editor)
  document.addEventListener('shopify:section:load', initProductTabs);
})();
